import { render, staticRenderFns } from "./ConfigTabMosaico.vue?vue&type=template&id=14a568de&scoped=true"
import script from "./ConfigTabMosaico.vue?vue&type=script&lang=js"
export * from "./ConfigTabMosaico.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabMosaico.vue?vue&type=style&index=0&id=14a568de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a568de",
  null
  
)

export default component.exports